export default __webpack_public_path__ + "static/media/hero-events.690de1db.jpg";